import * as types from "../actions/types";
/******************* 
@purpose : Intital home reducer data
@Author : INIC
******************/
const initialState = {
  sitemapDetails: [],
};

/******************* 
@purpose : Card Details Reducer
@Parameter : {ini_data, action}
@Author : INIC
******************/
export default function sitemap(ini_data = initialState, action = {}) {
  switch (action.type) {
    // Set Various Custom Redux Key Data /

    case types.SET_SITEMAP_DETAIL:      
      return Object.assign({}, ini_data, {
        sitemapDetails: action.data,
      });

    default:
      return ini_data;
  }
}
